// İçerik Stüdyosu — dışa aktarım biçimleri.
//
// Tek kaynak, üç çıktı: Markdown (arşiv/inceleme), HTML (CMS'e yapıştır) ve JSON
// (yeniden içeri al). Üçü de aynı `icerik` ağacından üretiliyor; biri diğerinden
// türetilmiyor ki Markdown'daki bir kaçış hatası HTML'i bozmasın.
//
// 🔑 HTML çıktısı gövde parçası — <html>/<body> sarmalı YOK. Sebebi WordPress:
// editöre tam belge yapıştırılınca kses etiketleri kırpıyor ve yazı yarım
// giriyor (bkz. heyglowy blog deneyimi).

const KACIS = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => KACIS[c]);

// Markdown'da başlık/liste işaretiyle başlayan bir paragraf yapıyı bozar.
const mdKac = (s) =>
  String(s ?? '')
    .replace(/\r/g, '')
    .replace(/^(\s*)([#>*+-]|\d+\.)\s/gm, '$1\\$2 ');

export const dosyaAdi = (icerik, uzanti) => {
  const taban =
    (icerik?.slug && String(icerik.slug)) ||
    String(icerik?.baslik || 'icerik')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60) ||
    'icerik';
  return `${taban}.${uzanti}`;
};

/* ──────────────────────────────── Markdown ──────────────────────────────── */

/* SEO gerekçesinin dışa aktarımdaki sırası ve başlıkları. Ekrandaki
   GEREKCE_ALANLARI ile aynı sıradır; müşteri dosyası bu sırayı bekliyor. */
const GEREKCE_SIRASI = [
  ['sorguNiyet', 'Hedeflenen ana sorgu ve arama niyeti'],
  ['veriGerekce', 'Konu seçimini destekleyen veri ve öncelik gerekçesi'],
  ['mevcutSayfa', 'Aynı ihtiyacı karşılayan mevcut sayfa'],
  ['yeniMiGelistirme', 'Yeni sayfa mı, mevcudun geliştirilmesi mi?'],
  ['icLinkHedef', 'Planlanan iç bağlantılar ve yönlendirilen sayfa'],
  ['kpi', 'Yayın sonrası takip edilecek başarı göstergesi'],
];

export function markdownUret(icerik, ustveri = {}) {
  const s = [];
  const alan = (k, v) => {
    if (v === null || v === undefined || v === '') return;
    s.push(`${k}: ${String(v).replace(/\n/g, ' ')}`);
  };

  s.push('---');
  alan('title', icerik.baslik);
  alan('slug', icerik.slug);
  alan('meta_title', icerik.metaBaslik);
  alan('meta_description', icerik.metaAciklama);
  alan('focus_keyword', ustveri.odakKelime || icerik.odakKelime);
  alan('language', ustveri.dil || 'tr');
  alan('status', ustveri.durum);
  alan('brand', ustveri.marka);
  alan('words', ustveri.kelimeSayisi);
  alan('image', icerik.gorsel?.url);
  alan('image_alt', icerik.gorsel?.alt);
  alan('generated_by', ustveri.model);
  alan('exported_at', new Date().toISOString());
  s.push('---', '');

  s.push(`# ${mdKac(icerik.baslik || '')}`, '');
  (icerik.girisParagraflari || []).forEach((p) => s.push(mdKac(p), ''));

  (icerik.bolumler || []).forEach((b) => {
    if (b?.h2) s.push(`## ${mdKac(b.h2)}`, '');
    (b?.paragraflar || []).forEach((p) => s.push(mdKac(p), ''));
    if (b?.maddeler?.length) {
      b.maddeler.forEach((m) => s.push(`- ${mdKac(m)}`));
      s.push('');
    }
    (b?.altBolumler || []).forEach((a) => {
      if (a?.h3) s.push(`### ${mdKac(a.h3)}`, '');
      (a?.paragraflar || []).forEach((p) => s.push(mdKac(p), ''));
      if (a?.maddeler?.length) {
        a.maddeler.forEach((m) => s.push(`- ${mdKac(m)}`));
        s.push('');
      }
    });
  });

  if (icerik.sonuc) s.push(`## Sonuç`, '', mdKac(icerik.sonuc), '');
  if (icerik.sss?.length) {
    s.push('## Sıkça Sorulan Sorular', '');
    icerik.sss.forEach((q) => {
      if (!q?.soru) return;
      s.push(`### ${mdKac(q.soru)}`, '', mdKac(q.cevap || ''), '');
    });
  }
  if (icerik.cta) s.push(mdKac(icerik.cta), '');

  // Yayın notları gövdenin DIŞINDA: bu blok CMS'e girmez, editöre bilgi verir.
  const notlar = [];
  if (icerik.icLinkler?.length) {
    notlar.push('### İç linkler');
    icerik.icLinkler.forEach((l) =>
      notlar.push(`- [${mdKac(l.ankor || l.url)}](${l.url})${l.neden ? ` — ${mdKac(l.neden)}` : ''}`)
    );
    notlar.push('');
  }
  if (icerik.gorselOnerileri?.length) {
    notlar.push('### Görsel önerileri');
    icerik.gorselOnerileri.forEach((g) =>
      notlar.push(`- **${mdKac(g.yer || '')}** — ${mdKac(g.aciklama || '')} _(alt: ${mdKac(g.alt || '')})_`)
    );
    notlar.push('');
  }
  if (icerik.notlar?.length) {
    notlar.push('### Yayın öncesi doğrulanacaklar');
    icerik.notlar.forEach((n) => notlar.push(`- ${mdKac(n)}`));
    notlar.push('');
  }
  if (notlar.length) s.push('---', '', '<!-- YAYIN NOTLARI — CMS\'e yapıştırma -->', '', ...notlar);

  // SEO gerekçesi müşteriye gidiyor: yazının neden yazıldığının altı başlıklık
  // cevabı. Yayın notlarından sonra, ayrı bölüm hâlinde.
  const g = ustveri.seoGerekce;
  if (g && GEREKCE_SIRASI.some(([k]) => String(g[k] || '').trim())) {
    s.push('---', '', '## SEO gerekçesi', '');
    GEREKCE_SIRASI.forEach(([anahtar, etiket]) => {
      const deger = String(g[anahtar] || '').trim();
      if (deger) s.push(`**${etiket}**`, '', mdKac(deger), '');
    });
  }

  return s.join('\n').replace(/\n{3,}/g, '\n\n');
}

/* ─────────────────────────────── düz metin ──────────────────────────────── */

/**
 * Biçimsiz düz metin: ne markdown işareti ne HTML etiketi.
 * Word/Docs'a, e-postaya ya da CMS'in görsel editörüne yapıştırmak için — orada
 * `##` ve `<p>` gövdeye harfi harfine giriyor ve elle temizlemek gerekiyordu.
 * Front matter ve yayın notları DIŞARIDA: bu çıktı yazının kendisi.
 */
export function duzMetinUret(icerik) {
  const s = [];
  const par = (v) => { const t = String(v ?? '').trim(); if (t) s.push(t, ''); };
  const madde = (list) => {
    (list || []).forEach((m) => { const t = String(m ?? '').trim(); if (t) s.push(`• ${t}`); });
    if ((list || []).some((m) => String(m ?? '').trim())) s.push('');
  };

  par(icerik.baslik);
  (icerik.girisParagraflari || []).forEach(par);

  (icerik.bolumler || []).forEach((b) => {
    par(b?.h2);
    (b?.paragraflar || []).forEach(par);
    madde(b?.maddeler);
    (b?.altBolumler || []).forEach((a) => {
      par(a?.h3);
      (a?.paragraflar || []).forEach(par);
      madde(a?.maddeler);
    });
  });

  if (icerik.sonuc) { par('Sonuç'); par(icerik.sonuc); }
  if (icerik.sss?.length) {
    par('Sıkça Sorulan Sorular');
    icerik.sss.forEach((q) => {
      if (!q?.soru) return;
      par(q.soru);
      par(q.cevap);
    });
  }
  par(icerik.cta);

  return s.join('\n').replace(/\n{3,}/g, '\n\n').trim();
}

/* ────────────────────────────────── HTML ────────────────────────────────── */

export function htmlUret(icerik, { jsonLd = true, ustveri = {} } = {}) {
  const h = [];
  // Kapak görseli gövdenin BAŞINA giriyor. WordPress'te öne çıkarılan görsel
  // ayrı bir alan; oraya elle koyulacaksa buradaki <figure> silinsin.
  if (icerik.gorsel?.url) {
    h.push(
      `<figure><img src="${esc(icerik.gorsel.url)}" alt="${esc(icerik.gorsel.alt || icerik.baslik || '')}" /></figure>`
    );
  }
  h.push(`<h1>${esc(icerik.baslik || '')}</h1>`);
  (icerik.girisParagraflari || []).forEach((p) => h.push(`<p>${esc(p)}</p>`));

  (icerik.bolumler || []).forEach((b) => {
    if (b?.h2) h.push(`<h2>${esc(b.h2)}</h2>`);
    (b?.paragraflar || []).forEach((p) => h.push(`<p>${esc(p)}</p>`));
    if (b?.maddeler?.length) {
      h.push('<ul>');
      b.maddeler.forEach((m) => h.push(`  <li>${esc(m)}</li>`));
      h.push('</ul>');
    }
    (b?.altBolumler || []).forEach((a) => {
      if (a?.h3) h.push(`<h3>${esc(a.h3)}</h3>`);
      (a?.paragraflar || []).forEach((p) => h.push(`<p>${esc(p)}</p>`));
      if (a?.maddeler?.length) {
        h.push('<ul>');
        a.maddeler.forEach((m) => h.push(`  <li>${esc(m)}</li>`));
        h.push('</ul>');
      }
    });
  });

  if (icerik.sonuc) {
    h.push('<h2>Sonuç</h2>');
    h.push(`<p>${esc(icerik.sonuc)}</p>`);
  }
  if (icerik.sss?.length) {
    h.push('<h2>Sıkça Sorulan Sorular</h2>');
    icerik.sss.forEach((q) => {
      if (!q?.soru) return;
      h.push(`<h3>${esc(q.soru)}</h3>`);
      h.push(`<p>${esc(q.cevap || '')}</p>`);
    });
  }
  if (icerik.cta) h.push(`<p><strong>${esc(icerik.cta)}</strong></p>`);

  if (jsonLd) {
    const blok = jsonLdUret(icerik, ustveri);
    if (blok) h.push('', '<!-- JSON-LD -->', blok);
  }
  return h.join('\n');
}

/**
 * Article + FAQPage şeması.
 * 🔴 WordPress'te bu bloğu YAZI GÖVDESİNE gömme — kses ve wptexturize script
 * etiketini kırpıyor, tırnakları bozuyor. Tema/eklenti alanına ya da head'e koy.
 */
export function jsonLdUret(icerik, ustveri = {}) {
  const graf = [];
  graf.push({
    '@type': 'Article',
    headline: String(icerik.metaBaslik || icerik.baslik || '').slice(0, 110),
    description: icerik.metaAciklama || undefined,
    inLanguage: ustveri.dil === 'en' ? 'en' : 'tr',
    author: ustveri.marka ? { '@type': 'Organization', name: ustveri.marka } : undefined,
    publisher: ustveri.marka ? { '@type': 'Organization', name: ustveri.marka } : undefined,
  });
  const sss = (icerik.sss || []).filter((q) => q?.soru && q?.cevap);
  if (sss.length) {
    graf.push({
      '@type': 'FAQPage',
      mainEntity: sss.map((q) => ({
        '@type': 'Question',
        name: q.soru,
        acceptedAnswer: { '@type': 'Answer', text: q.cevap },
      })),
    });
  }
  const veri = { '@context': 'https://schema.org', '@graph': graf };
  return `<script type="application/ld+json">\n${JSON.stringify(veri, null, 2)}\n</script>`;
}

/* ─────────────────────────────── indirme ────────────────────────────────── */

export function indir(icerikMetni, ad, tip = 'text/plain;charset=utf-8') {
  const blob = icerikMetni instanceof Blob ? icerikMetni : new Blob([icerikMetni], { type: tip });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = ad;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Hemen revoke etmek Safari'de indirmeyi iptal ettiriyor.
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export async function panoyaKopyala(metin) {
  try {
    await navigator.clipboard.writeText(metin);
    return true;
  } catch {
    // clipboard API https ve izin istiyor; başarısızlıkta eski yöntem.
    const ta = document.createElement('textarea');
    ta.value = metin;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  }
}

/* ─────────────────────────── toplu (ZIP) aktarım ────────────────────────── */

export function csvSatir(alanlar) {
  return alanlar
    .map((a) => {
      const s = String(a ?? '');
      return /[",\n;]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
    })
    .join(';');
}

/**
 * Seçili kayıtları tek ZIP'e koyar: her yazı için .md ve .html, bir de
 * index.csv + tumu.json. CSV ayracı noktalı virgül — Excel TR yerelinde virgül
 * ayracını sütuna bölmüyor.
 */
export async function zipUret(kayitlar, marka) {
  const JSZip = (await import('jszip')).default;
  const zip = new JSZip();
  const kok = zip.folder('icerik');
  const satirlar = [
    csvSatir(['id', 'baslik', 'slug', 'dil', 'durum', 'odak_kelime', 'kelime', 'puan', 'guncellendi']),
  ];

  kayitlar.forEach((k) => {
    const icerik = k.icerik || {};
    const ustveri = {
      marka,
      dil: k.dil,
      durum: k.durum,
      odakKelime: k.odakKelime,
      kelimeSayisi: k.kelimeSayisi,
      model: k.model,
      seoGerekce: k.seoGerekce,
    };
    const taban = (icerik.slug || k.slug || `icerik-${k.id}`).replace(/[^a-z0-9-]/gi, '-');
    kok.file(`${taban}.md`, markdownUret(icerik, ustveri));
    kok.file(`${taban}.html`, htmlUret(icerik, { ustveri }));
    satirlar.push(
      csvSatir([
        k.id,
        icerik.baslik || k.baslik,
        k.slug,
        k.dil,
        k.durum,
        k.odakKelime,
        k.kelimeSayisi,
        k.denetim?.ozet?.puan ?? '',
        k.updatedAt,
      ])
    );
  });

  // BOM: Excel UTF-8'i aksi halde Türkçe karakterlerde bozuyor.
  // Müşteriye giden "bu yazı neden yazıldı" tablosu. Altı başlık yazı başına bir
  // satır; ayrı dosya, çünkü içerik dosyalarından bağımsız paylaşılıyor.
  const gerekceSatirlari = [
    csvSatir(['baslik', 'odak_kelime', ...GEREKCE_SIRASI.map(([, etiket]) => etiket)]),
  ];
  kayitlar.forEach((k) => {
    const g = k.seoGerekce || {};
    gerekceSatirlari.push(
      csvSatir([
        (k.icerik || {}).baslik || k.baslik,
        k.odakKelime,
        ...GEREKCE_SIRASI.map(([anahtar]) => g[anahtar] || ''),
      ])
    );
  });
  zip.file('seo-gerekce.csv', '﻿' + gerekceSatirlari.join('\n'));

  zip.file('index.csv', '﻿' + satirlar.join('\n'));
  zip.file('tumu.json', JSON.stringify({ marka, disaAktarildi: new Date().toISOString(), kayitlar }, null, 2));
  return zip.generateAsync({ type: 'blob' });
}
